import { render, staticRenderFns } from "./InventoryBulkEditModal.vue?vue&type=template&id=45b9a2a9&scoped=true"
import script from "./InventoryBulkEditModal.vue?vue&type=script&lang=js"
export * from "./InventoryBulkEditModal.vue?vue&type=script&lang=js"
import style0 from "./InventoryBulkEditModal.vue?vue&type=style&index=0&id=45b9a2a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b9a2a9",
  null
  
)

export default component.exports